import Api from './Api';

class _BibleApi extends Api {
    load(): Promise<any> {
        return this.getHttpClient().get(`bible`);
    }

    saveBook(params: any): Promise<any> {
        return this.getHttpClient().post(`bible/book`, params);
    }

    deleteBook(id: number): Promise<any> {
        return this.getHttpClient().delete(`bible/book/${id}`);
    }

    saveChapter(params: any): Promise<any> {
        return this.getHttpClient().post(`bible/chapter`, params);
    }

    deleteChapter(id: number): Promise<any> {
        return this.getHttpClient().delete(`bible/chapter/${id}`);
    }
}

export const BibleApi = new _BibleApi();
